module.exports = __webpack_public_path__ + "img/slide_p6.fa8580a0.png";